/**
 * Custom error class for Deepgram API key generation failures.
 * Used to distinguish API key errors from other errors in error handling.
 */
export class DeepgramApiKeyError extends Error {
  constructor(
    message: string,
    public readonly originalError?: unknown,
  ) {
    super(message);
    this.name = 'DeepgramApiKeyError';
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, DeepgramApiKeyError);
    }
  }
}
